import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	statusFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unavailableStatusText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	helperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noEnabledTransitionsMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unavailableStatusTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningMessageIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manageWorkflowFooter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusFieldLabel: {
		id: 'issue-create.modal.create-form.status-field.status-field-label',
		defaultMessage: 'Status',
		description: 'Label for status field in issue create form',
	},
	unavailableStatusText: {
		id: 'issue-create.modal.create-form.status-field.unavailable-status-text',
		defaultMessage: "Your workflow doesn't allow issues to be created in this status",
		description: 'Tooltip text for disabled status transition',
	},
	helperText: {
		id: 'issue-create.modal.create-form.status-field.helper-text',
		defaultMessage: 'This is the initial status upon creation',
		description: 'Text to help with understanding what the status field is used for',
	},
	noEnabledTransitionsMessage: {
		id: 'issue-create.modal.create-form.status-field.no-enabled-transitions-message',
		defaultMessage: 'There are no statuses available for you to use',
		description:
			'Message shown inside the status field dropdown when no non-default statuses are available',
	},
	warningIconLabel: {
		id: 'issue-create.modal.create-form.status-field.warning-icon-label',
		defaultMessage: 'Warning',
		description: 'Accessibility label for the warning icon',
	},
	warningMessage: {
		id: 'issue-create.modal.create-form.status-field.warning-message',
		defaultMessage:
			'This field isn’t working right now. You can still create your issue and update the status later.',
		description:
			'Warning message to display when status in GIC has failed to load (this will replace `issue-create.modal.create-form.status-field.error-message)`',
	},
	unavailableStatusTextIssueTermRefresh: {
		id: 'issue-create.modal.create-form.status-field.unavailable-status-text-issue-term-refresh',
		defaultMessage: "Your workflow doesn't allow work items to be created in this status",
		description: 'Tooltip text for disabled status transition',
	},
	warningMessageIssueTermRefresh: {
		id: 'issue-create.modal.create-form.status-field.warning-message-issue-term-refresh',
		defaultMessage:
			'This field isn’t working right now. You can still create your work item and update the status later.',
		description:
			'Warning message to display when status in GIC has failed to load (this will replace `issue-create.modal.create-form.status-field.error-message)`',
	},
	warningMessageIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.status-field.warning-message-issue-terminology-refresh-m4',
		defaultMessage:
			'This field isn’t working right now. You can still create the {issueType} and update the status later.',
		description:
			'Warning message to display when status in GIC has failed to load (this will replace `issue-create.modal.create-form.status-field.error-message)`. Please translate as “work type {issueType}”',
	},
	manageWorkflowFooter: {
		id: 'issue-create.modal.create-form.status-field.manage-workflow',
		defaultMessage: 'Manage workflow',
		description: 'Label of manage workflow button',
	},
});
export default messages;
